/* eslint-disable import/no-default-export */
import { normalizeUpNext } from 'api/normalize';
// eslint-disable-next-line no-restricted-imports
import { UpNextModel } from 'types';
// eslint-disable-next-line no-restricted-imports
import { createReducer } from 'util/reducers';

// eslint-disable-next-line no-restricted-imports
import {
  DISMISS_UP_NEXT_SUCCESS,
  DismissUpNextSuccessAction,
  LOAD_UP_NEXT_SUCCESS,
  LoadUpNextSuccessAction,
} from 'modules/loaders';

export type UpNextState = UpNextModel[];

const initialState: UpNextState = [];

export default createReducer(initialState, {
  [LOAD_UP_NEXT_SUCCESS](state, { payload }: LoadUpNextSuccessAction) {
    return payload.map((upNext) => normalizeUpNext(upNext));
  },

  [DISMISS_UP_NEXT_SUCCESS](state, { payload }: DismissUpNextSuccessAction) {
    return state.filter((upNext) => upNext.id !== payload.idUpNext);
  },
});



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/models/up-next.ts